import type { ComponentProps } from 'react';
import { cn } from './utils';

const base =
  'w-full rounded-[14px] border border-line bg-panel px-3.5 text-ink transition-[border-color,box-shadow,background-color] placeholder:text-muted/60 hover:border-muted/40 focus:border-brand focus:bg-panel focus:ring-4 focus:ring-brand/15 focus:outline-none disabled:opacity-60 aria-invalid:border-gap aria-invalid:ring-1 aria-invalid:ring-gap dark:bg-tile';

export function Input({ className, ...props }: ComponentProps<'input'>) {
  // In a Hebrew page the browser lays a time field out right to left, so 14:00 reads "00:14".
  const time = props.type === 'time';
  return (
    <input dir={time ? 'ltr' : undefined} className={cn(base, 'min-h-11', className)} {...props} />
  );
}

/** Numeric input: large, LTR digits, decimal keyboard on phones. */
export function NumberInput({ className, ...props }: Omit<ComponentProps<'input'>, 'type'>) {
  return (
    <input
      type="text"
      inputMode="decimal"
      dir="ltr"
      autoComplete="off"
      className={cn(base, 'min-h-11 text-center font-semibold tabular-nums', className)}
      {...props}
    />
  );
}

export function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return <textarea className={cn(base, 'min-h-24 py-2', className)} {...props} />;
}

export function Select({ className, ...props }: ComponentProps<'select'>) {
  return <select className={cn(base, 'select-chevron min-h-11 pe-8', className)} {...props} />;
}
